<template>
    <Dialog :show="show" :has-backdrop="true" :show-close-button="true" @close="$emit('close')"
            width="800px">
        <div class="content">
            <h4>Preset anlegen</h4>
            <div class="name wrapper">
                <Input label="Name" :style="{marginRight: '40px'}" v-model="name"></Input>
                <Dropdown label="Gruppe" :items="groups" initial="Keine Gruppe" :selectOnClick="true"
                          :delete-selected="false" :key="keyLoader" @enter="groupSelected"></Dropdown>
            </div>
            <div class="visibility wrapper">
                <div class="icon_wrapper">
                    <Checkbox title="Private" id="0" v-model="isPrivate"></Checkbox>
                    <unicon name="lock-alt" fill="#d0d4da"></unicon>
                </div>
                <div class="icon_wrapper">
                    <Checkbox title="Public" id="1" v-model="isPublic">></Checkbox>
                    <unicon name="unlock-alt" fill="#d0d4da"></unicon>
                </div>
            </div>
            <PresetFilter :columns="filterColumns" :key="keyLoader" @update="updateColumns"
                          :initialize="false"></PresetFilter>
            <div class="button wrapper">
                <AdaButton :style="{marginRight: '20px'}" title="Preset erstellen" @click="createPreset"
                           :loading="creatingLoader"></AdaButton>
                <AdaButton type="button grey" title="Abbrechen" @click="$emit('close')"></AdaButton>
            </div>
        </div>
    </Dialog>
</template>

<script>
    import Dialog from "../../components/dialogs/Dialog";
    import Input from "../../components/inputs/Input";
    import Dropdown from "../../components/inputs/DropDown";
    import Checkbox from "../../components/inputs/Checkbox";
    import {RepositoryFactory} from "../../scripts/RepositoryFactory";
    import PresetFilter from "../MyDeals/components/preset/PresetFilter";
    import AdaButton from "../../components/buttons/AdaButton";

    const PresetRepository = RepositoryFactory.get('presets');

    export default {
        name: "CreatePresetDialog",
        components: {AdaButton, PresetFilter, Checkbox, Dropdown, Input, Dialog},
        props: {
            show: {
                type: Boolean,
                default: false,
            }
        },
        data: () => {
            return {
                loading: true,
                keyLoader: 0,
                selectedGroup: null,
                name: '',
                isPrivate: true,
                isPublic: false,
                columns: [],
                creatingLoader: false
            }
        },
        mounted() {
            if (this.groups.length === 1 || this.settingsChangesMade) {
                this.fetchGroups();
            }
            this.fetchColumns();
        },
        computed: {
            vuexState() {
                return this.$store.state.columns;
            },
            settingsChangesMade() {
                return this.$store.state.settings.changesMade;
            },
            groups() {
                return this.$store.getters['presets/groups'];
            },
            filterColumns() {
                return this.vuexState.filterColumns;
            }
        },
        methods: {
            async fetchGroups() {
                await this.$store.dispatch('presets/fetchGroups', true);
            },
            async fetchColumns() {
                if (this.vuexState.filterColumns.length === 0) {
                    await this.$store.dispatch('columns/fetch', true);
                }
            },
            async createPreset() {
                try {
                    if(this.name === ""){
                        this.$noty.warning('Bitte einen Preset Namen angeben');
                        return;
                    }
                    this.creatingLoader = true;
                    // eslint-disable-next-line no-undef
                    let user = sso.getSsoUser();
                    let json = {
                        name: this.name,
                        private: this.isPrivate,
                        public: this.isPublic,
                        group: this.selectedGroup.name === 'Keine Gruppe' ? null : this.selectedGroup,
                        user_id: user.id,
                        author_id: user.id,
                    };
                    let columnsCopy = JSON.parse(JSON.stringify(this.columns));
                    for (let i = 0; i < columnsCopy.length; i++) {
                        if(typeof columnsCopy[i].pivot.filter_value !== "undefined" && Array.isArray(columnsCopy[i].pivot.filter_value)){
                            columnsCopy[i].pivot.filter_value = columnsCopy[i].pivot.filter_value.join(';');
                        }
                    }
                    json.columns = columnsCopy;
                    const {data} = await PresetRepository.createPreset(json);
                    if (data.status === "created") {
                        this.$store.commit('presets/addPreset', {data: data.result});
                        this.$root.$emit('showCreatePresetDialog', false);
                        this.$router.push({ name: 'mydeals', params: { id: data.result.id } });

                        this.$noty.success('Preset erfolgreich angelegt');
                    } else {
                        this.$noty.error('Fehler beim Anlegen des Presets');
                    }
                    this.creatingLoader = false;
                } catch (e) {
                    this.$noty.error('Fehler beim Anlegen des Presets');
                    this.creatingLoader = false;
                }

            },
            groupSelected(group) {
                this.selectedGroup = group;
            },
            updateColumns(data) {
                this.columns = data;
            },
        },
        watch:{
            isPrivate(value){
                this.isPublic = value === false;
            },
            isPublic(value){
                this.isPrivate = value === false;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        display: flex;
        flex-flow: column;
        width: 100%;
    }

    .wrapper {
        display: flex;
        flex-flow: wrap;
    }

    .icon_wrapper {
        display: flex;
        align-items: center;
        margin-right: 10px;

        .checkbox-container {
            margin-right: 10px;
        }
    }

    .button{
        margin-top: 30px;
    }
</style>